import React from 'react'
import { useParams } from 'react-router-dom'
import { Pagination } from 'lib/shared/components'
import { FadeIn, Spinner, EmptyContainer } from 'lib/ui/components'
import { MetaData } from 'components/MetaData'
import { useBlogContext } from 'hooks/blog'
import { MainTitle } from '../../components/MainTitle'
import { NoPosts } from '../../components/NoPosts'
import { PostsGrid } from '../../components/PostsGrid'
import { PaginationStyles } from 'components/PaginationStyles'
import { PaginationWrapper } from './components/Styled'
import { useBlogConfig } from 'lib/core/hooks'

export const Category = () => {
  const { slug } = useParams<{ slug: string }>()
  const {
    name,
    postSlugs,
    posts: items,
    handlePageChange,
    pageInfo,
    loading: isFetching,
    isViewAll
  } = useBlogContext()

  const { config, loading } = useBlogConfig()

  if (loading) {
    return (
      <EmptyContainer>
        <Spinner />
      </EmptyContainer>
    )
  }

  return (
    <>
      {config && (
        <MetaData
          title={config?.getBlogConfig.meta_title}
          description={config?.getBlogConfig.meta_description}
          keywords={config?.getBlogConfig.meta_keywords}
        />
      )}
      <FadeIn
        key={`title-${slug}`}
      >
        <MainTitle
          title={name}
        />
      </FadeIn>

      {!postSlugs || isFetching || !items?.length ? (
        <EmptyContainer>
          <Spinner />
        </EmptyContainer>
      ) : (
        <FadeIn
          key={`content-${slug}`}
        >

          {items.length ? (
            <>
              <PostsGrid
                title={isViewAll ? 'All Articles' : 'Most Recent'}
                posts={items}
              />
            </>
          ) : (
            <NoPosts />
          )}

          <PaginationWrapper>
            <PaginationStyles>
              {pageInfo && (
                <Pagination
                  currentPage={pageInfo?.currentPage}
                  pageSize={pageInfo?.pageSize}
                  totalItems={pageInfo?.totalItems}
                  onChange={handlePageChange}
                />
              )}
            </PaginationStyles>
          </PaginationWrapper>
        </FadeIn>
      )}
    </>
  )
}
